export class UpdateInventoryOrderActiveSiderSection {
  static readonly type = '[INVENTORY_ORDER] Update active sider section';
  constructor(public name: string) {}
}
